import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import * as authTypes from "./constants/authTypes";

interface AnonymousAuthWrapperProps {
  children: JSX.Element;
}

const AnonymousAuthWrapper = ({ children }: AnonymousAuthWrapperProps) => {
  return (
    <BrowserRouter>
      <AuthProvider authType={authTypes.ANONYMOUS}>
        <Routes>
          <Route path="/" element={children} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default AnonymousAuthWrapper;
